import { getPromoModalType } from '../promos/promoUtils';
import PromoDetailsModal from './PromoDetailsModal';
import TournamentModal from './TournamentModal';

export default function PromoModalRouter({ promo, onClose, onRegister }) {
  if (!promo) return null;

  const modalType = getPromoModalType(promo);
  if (modalType === 'tournament') {
    return <TournamentModal promo={promo} onClose={onClose} onRegister={onRegister} />;
  }

  // welcome + cashback + all action landing modals share Fonbet-style details modal
  return <PromoDetailsModal promo={promo} onClose={onClose} onRegister={onRegister} />;
}
